var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Overview of participations")]),
      _c("bar-chart-participation", {
        attrs: { chartData: _vm.participantsdata }
      }),
      _c("div", { attrs: { id: "tooltip" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }